<script setup>
import { onLaunch, onShow } from '@dcloudio/uni-app'
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'
import { useUserStore } from '@/store/user'
import { postLogin } from '@/api/select'
import VConsole from 'vconsole'
import * as ww from '@wecom/jssdk'
import { getAgentConfig, getCorpTicket, getAgentTicket, getSdkSign } from '@/api/qywx'
import { getNonce } from '@/utils/qywx'

const userStorePin = useUserStore()
const timestamp = Math.floor(Date.now() / 1000).toString()
const nonceStr = getNonce()
const corpTicket = ref('')
const agentTicket = ref('')
const agentConfig = reactive({
  corpId: '',
  agentId: '',
})

const isBi = () => {
  return window.location.pathname.includes('/pages-sub/bi-links/')
}

const getJsapiTicket = async () => {
  const [agentConfigs, corpTicketConfig, agentTicketConfig] = await Promise.all([
    isBi()
      ? {
          context: {
            agentId: import.meta.env.VITE_BI_AGENT_ID,
            corpId: import.meta.env.VITE_BI_CORP_ID,
          },
        }
      : getAgentConfig(),
    getCorpTicket(),
    getAgentTicket(),
  ])

  agentConfig.corpId = agentConfigs.context.corpId
  agentConfig.agentId = agentConfigs.context.agentId
  corpTicket.value = corpTicketConfig.context
  agentTicket.value = agentTicketConfig.context
}

const getConfigSignature = async (url) => {
  const { context } = await getSdkSign({
    timestamp,
    nonceStr,
    url,
    ticket: corpTicket.value,
  })
  return { timestamp, nonceStr, signature: context }
}

const getAgentConfigSignature = async (url) => {
  const { context } = await getSdkSign({
    timestamp,
    nonceStr,
    url,
    ticket: agentTicket.value,
  })
  return { timestamp, nonceStr, signature: context }
}

const registerInit = async () => {
  ww.register({
    corpId: agentConfig.corpId,
    agentId: agentConfig.agentId,
    jsApiList: [
      'saveApprovalSelectedItems',
      'getApprovalSelectedItems',
      'hideMenuItems',
      'getCurExternalContact',
    ], // 企业级 API
    getConfigSignature, // 必填，根据url生成企业签名的回调函数
    getAgentConfigSignature, // 必填，根据url生成应用签名的回调函数
    onConfigSuccess() {
      console.log('onConfigSuccess success')
    },
    onConfigFail(res) {
      console.error(res)
    },
    onAgentConfigSuccess() {
      console.log('onAgentConfigSuccess success')
    },
    onAgentConfigFail(res) {
      console.error(res)
    },
  })
}

const login = async (qywxId, options) => {
  const { context } = await postLogin({
    loginType: 'QYWX', // 登录类型 固定
    qywxId, // 企业微信ID
  })
  userStorePin.setUserInfo(context)
  if (options.query.type === 'MASS_JUDGE_DETAIL') {
    uni.reLaunch({
      url:
        '/pages-sub/selectReview/index?id=' + options.query.id + '&qywxId=' + options.query.qywxId,
    })
  } else if (options.query.type === 'USER_SURVEY_ADD') {
    uni.reLaunch({
      url:
        '/pages-sub/custResearch/index?qywxId=' + options.query.qywxId + '&id=' + options.query.id,
    })
  }
}

onLaunch((options) => {
  console.log('App Launch', options)

  // isBi 单独页面登陆处理
  if (options.query.qywxId && !isBi()) login(options.query.qywxId, options)

  if (import.meta.env.VITE_SHOW_VCONSOLE === 'true') {
    const vConsole = new VConsole({
      maxLogNumber: 100,
      theme: 'dark',
    })
  }
})

onShow(async () => {
  await getJsapiTicket()
  await registerInit()
})
</script>

<style lang="scss">
@use '/src/style/ipad/index.scss' as *;
@import '/src/style/index';

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
